import { createSlice } from "@reduxjs/toolkit";

// Holds the logged-in user's permission payload and related notification data used
// across protected screens.
const permissionDataSlice = createSlice({
  name: "permissionData",
  initialState: {
    user: null,
    userPermissionData: null,
    notificationData: null,
    permissionModules: [],
    accessData: null,
    accessReady: false,
  },

  reducers: {
    // Save the permission object returned after login or permission refresh.
    addUserPermissionData: (state, action) => {
      state.userPermissionData = action.payload;
    },
    // Keep notification data globally available for header and panel components.
    addNotificationData: (state, action) => {
      state.notificationData = action.payload;
    },
    // Seeded permission modules catalog used by group and access screens.
    addPermissionModules: (state, action) => {
      state.permissionModules = Array.isArray(action.payload)
        ? action.payload
        : [];
    },
    // Logged-in admin access payload from GET /admin/data.
    addAccessData: (state, action) => {
      const access = action.payload ?? null;
      state.accessData = access;
      state.accessReady = true;
      state.user = access
        ? {
            id: access.id ?? null,
            type: access.type || "",
            name: access.name || "",
            email: access.email || "",
            mobileNumber: access.mobileNumber || "",
          }
        : null;
    },
  },
});

export const {
  addUserPermissionData,
  addNotificationData,
  addPermissionModules,
  addAccessData,
} = permissionDataSlice.actions;

export const selectPermissionModules = (state) =>
  state.userPermission.permissionModules || [];

export const selectAccessData = (state) =>
  state.userPermission.accessData;

export const selectAccessReady = (state) =>
  Boolean(state.userPermission.accessReady);

export const selectCurrentUser = (state) =>
  state.userPermission.user;

export default permissionDataSlice.reducer;
